export default class ProductCategoriesHtml {
    constructor(headline, items, category) {
        this._headline = headline;
        this._items = items;
        this._category = category;
    }

    _getItemHtml() {
        // eslint-disable-next-line no-undef
        const $globalConfig = config;
        let itemsHtml = '';
        this._items.forEach((item) => {
            item.categories.forEach((category) => {
                const nameArray = category.name.split('#');
                const idArray = category.identifier.split('#');
                let html = '';

                nameArray.forEach((name, i) => {
                    const urlParam = i !== (nameArray.length - 1) ? `${$globalConfig.urls.categoryHtml}?cat=${idArray[i]}` : `${$globalConfig.urls.searchHtml}?cat=${idArray[i]}`;

                    html += `
                        <a href="${urlParam}" class="rfct-product-detail-categories__link">
                            ${name}
                        </a>
                    `;
                });

                itemsHtml += `
                    <li class="rfct-product-detail-categories__link-list-item">
                        ${html}
                    </li>
                `;
            });
        });

        return itemsHtml;
    }

    toString() {
        return `
            <div class="rfct-product-detail-categories">
                <h3 class="rfct-product-detail-categories__headline">${this._headline}</h3>
                <ul class="rfct-product-detail-categories__link-list">
                    ${this._getItemHtml()}
                </ul>
            </div>
        `;
    }
}
